import layerEvents from "../utils/layerEvents";
import Workmode from "../classes/Workmode";
import vindrApi from "../utils/vindrapi";
import {Dropdown, Button, Row, Col} from "react-bootstrap";
import {formatArea} from "../utils/functions";

import { Crosshair, DotsThreeVertical, Trash, Book,PencilLine,CircleNotch, Warning, Plus, Palette, Pentagon, Info, Building, Polygon  } from "@phosphor-icons/react";


class WorkmodeProject extends Workmode{

	needsReload = true;

	constructor() {
		super();

	}
	clear(){
		
	}
	
	fetchOwner(row, e){
		//row is of type owner
		
		e.target.closest(".context-menu").classList.add("loading");
		
		super.fetchOwner([row.properties[0].vindrid], this.getCountry())
			.then((result)=>{
				
				if(!result.data){
					e.target.closest(".context-menu").classList.replace("loading","error");
				}
				else{

					e.target.closest(".context-menu").classList.remove("loading");
					
					if(row.properties[0].vindrid && result.data[row.properties[0].vindrid] )
						this.handleFetchOwner(result.data[row.properties[0].vindrid], row.properties[0].vindrid);

				}
				
			
			});
		
		
		
		
	}
	fetchBulkOwners(owners){
		
		var lands = [];
		owners.forEach((o)=>{
			lands.push(o.properties[0].vindrid);
		});
		
		return vindrApi.getPlotInfoProgressive(lands, this.getCountry(), 'project', this.context.getters.project.projectid);
	}
	
	
	handleFetchBulkOwners(owners, unknowns){
		
		var promises = [];
		
		owners.forEach((o, idx)=>{
			this.handleFetchOwner([o], o.properties[0].id);
		});
		
	}
	
	handleEditOwner(owner){
		this.setEditOwner({open:true, owner:owner, onSave:this.handleSaveOwner});
	}
	handleCreateOwner(owner, vindrId){
		this.setEditOwner({open:true, owner:owner, onSave:(owner)=>{this.handleSelectOwner(owner, vindrId);}});
	}

	handleFetchOwner = (owners, vindrId) => {
		
		const {QN, dialogs, getters} = this.context;
		
		if(!owners.length)
			return;
		
		var newScenario  = {...this.tc.scenario};
		

		var newOwner = [];
		
		
		//cycle between owners list
		var idx = newScenario.landowners.findIndex((o)=>{
			//cycle on each property of current owner
			return o.properties.find((p)=>{return p.vindrid == vindrId});
		});
		
		if(idx > -1 ) {

			owners.forEach((i, j)=>{
				i.color = i.color ? i.color : process.env.REACT_APP_PLOT_NO_OWNER_COLOR;
				i.turbines = 0;
				i.unknown = false;
				i.number = newScenario.landowners[idx].number + j;
				if(!i.fullName)
					i.fullName = i.companyName ? i.companyName : i.firstName+' '+i.lastName;
				return i; 
			});
			Array.prototype.splice.apply(newScenario.landowners, [...[idx, 1], ...owners]);
			
			//update the rest of the numbers in the list after the inte
			if(owners.length > 1){
				for(let h = idx + owners.length; h < newScenario.landowners.length; h++){
					newScenario.landowners[h].number += (owners.length-1);
				}
			}
		}
		
		//replace property info in plots
		var found = false;
		newScenario.properties.features.forEach((p, idx)=>{
			found = found !== false ? found : (p.properties.vindrid == vindrId ? idx : false);
			
			if(p.properties.vindrid == vindrId){

				var plotLegend = owners.map((o, i)=>{
					return o.number;
				}).join(", ");
				
				p.properties.color = owners[0].color ? owners[0].color : process.env.REACT_APP_PLOT_NO_OWNER_COLOR;
				p.properties.ownerid = owners.map((o)=>{return o.id});
				p.properties.description = plotLegend;
				p.ownerid = true;	
				
				
			}
			//entries after the modified plot
			if(found && p.properties.vindrid != vindrId && owners.length>1){
				//correct the legend for the plots after the affected plot
				if(p.properties.description)
					p.properties.description = p.properties.description.toString().split(", ").map((n)=>{return parseInt(n)+owners.length-1;}).join(", ");
			}
		});

		this.refreshMap(newScenario);
		
		this.setOwners(newScenario.landowners);	
				
				
				
		this.tc.setScenario(newScenario);
		
		owners.forEach((i)=>{
			QN.current.show(i.fullName+" was assigned as owner to property "+vindrId);
		});


	}
	refreshMap(newScenario){
		if(this.map.getSource('project-geojson')){
			this.map.getSource("project-geojson").setData(newScenario.properties);
			this.map.currentData = newScenario.properties;
		}
	}
	setEvents(){
		
		this.map.setLayoutProperty("owner-numbers", "visibility", this.map.layerStatus['owner-numbers'] ? 'visible' : 'none');
		this.map.setLayoutProperty("status-numbers", "visibility", this.map.layerStatus['status-numbers'] ? 'visible' : 'none');
		this.map.setLayoutProperty("project-geojson-stroke", "visibility", this.map.layerStatus['project-geojson-stroke'] ? 'visible' : 'none');
		this.map.setLayoutProperty("project-geojson-fill", "visibility", this.map.layerStatus['project-geojson-fill'] ? 'visible' : 'none');

	}
	exitWorkmode(){

		this.map.setLayoutProperty("owner-numbers", "visibility", 'none');
		this.map.setLayoutProperty("status-numbers", "visibility", 'none');
		this.map.setLayoutProperty("project-geojson-stroke", "visibility", 'none');
		this.map.setLayoutProperty("project-geojson-fill", "visibility", 'none');
	}

	openAssociateDialog(vindrId){
		
		const {dialogs} = this.context;
		
		
		dialogs.setAssocDialog({
			open:true,
			onNoResults: (needle)=>{return this.handleNoResults(needle, vindrId);},
			onSelect: (owner)=>{this.handleSelectOwner(owner, vindrId);}
			
		});
		
		
	}
	closeAssociateDialog(){
		const {dialogs} = this.context;
		
		
		dialogs.setAssocDialog({
			open:false,
			onNoResults: (needle)=>{},
			onSelect: (owner)=>{}
		});
		
	}
	openDissasociateProperty(row){
		const {dialogs} = this.context;
		
		dialogs.setDisassocProp({
			open:true,
			owner:row,
			property:row.properties[0].id 
		});
	}
	handleSelectOwner(owner, vindrId){
		
		owner.totalArea = 0;
		
		const plotProperties = this.tc.scenario.properties.features.find((p)=>{
			return p.properties.vindrid == vindrId;
		});

		plotProperties.ownerid = [owner.id];
		
		
		owner.properties = Array.isArray(owner.properties) ? owner.properties.push(plotProperties.properties) : [plotProperties.properties];
		
		
		
		vindrApi.updatePropertyOwner({propertyId:vindrId, projectId:this.tc.scenario.projectid, scenarioId:this.tc.scenario.scenario_id}, owner.id);

		this.handleFetchOwner([owner], vindrId);
		this.closeAssociateDialog();
	}
	handleNoResults(needle, vindrId){
		
		var swap = needle.split(" ");
		var temp = {firstName:swap.slice(0, -1).join(" "), lastName:swap[swap.length-1]};
		
		
		return <Button className="btn-land-actions" onClick={(e)=>{this.handleCreateOwner(temp, vindrId);}}><Plus size={16} /> Create new owner "{needle}"</Button>
	}
	openChangeColorDialog(row){
		
		const {dialogs} = this.context;
		
		
		dialogs.setChangeColor({
			open:true,
			onSave: (data)=>{this.updateOwnerById(data.id, data)},
			owner: row
		});
		
		
	}
	updateOwnerById(id, newData){
		
		const {getters, setters} = this.context;
		var owners = getters.owners;
		
		var idx = owners.findIndex((o)=>o.id==id);
		if(idx>-1) {
			setters.setOwners((owners)=> {
				owners[idx] = {...owners[idx], ...newData};
				return owners;
			})
		}
		if(getters.owner && getters.owner.id == id){
			var newOwner = {...getters.owner, ...newData};
			
			
			setters.setOwner(newOwner);
		}

		this.updatePropertyColor(newData.id, newData.color);
		
	}
	updatePropertyColor(uId, color){
		
		uId = !Array.isArray(uId) ? [uId] : uId;
		
		var newScenario  = {...this.tc.scenario};
		
		uId.forEach((u)=>{
			newScenario.properties.features.forEach((p)=>{
				if(p.properties.ownerid.includes(u))
					p.properties.color = color;	
			});
		});
		

		this.refreshMap(newScenario);
		
		this.tc.setScenario(newScenario);
	}
	
	
	
	
	
	contextMenu(){
		
		
		return [{
			name:'',
			cell: row => (
				<div className="context-menu" data-tag="allowRowEvents">
						<Dropdown className="minimal">
							<Dropdown.Toggle className="p-0 px-1" variant="default">
								<DotsThreeVertical size={16} />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{!!row.unknown && 
									<>
										<Dropdown.Item href="#" onClick={(e)=>{this.fetchOwner(row, e); }}><Book weight="bold" size={16} /> Fetch landowner</Dropdown.Item>
										<Dropdown.Item href="#" onClick={(e)=>{this.openAssociateDialog(row.properties[0].vindrid); }}><PencilLine  weight="bold"  size={16} /> Assign manually</Dropdown.Item>
									</>
								}
								{(!row.unknown || !!row.color) &&
								<>
									<Dropdown.Item href="#" onClick={(e)=>{this.openChangeColorDialog(row); }}><Palette  weight="bold"  size={16} /> Edit landowner color</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.handleEditOwner(row); }}><PencilLine  weight="bold"  size={16} /> Edit landowner</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.openDissasociateProperty(row); }} className="text-danger" ><Trash  weight="bold" size={16} /> Detach owner</Dropdown.Item>
								</>
								
								}
							</Dropdown.Menu>
						</Dropdown>
						<CircleNotch className="spin" size={16} />
						<Warning className="text-danger" size={16} />
				</div>
			),
			width:"20px",
			style: {
				paddingRight: '.3em !important',
			}
		}];
	}
	
	propertyAttributes(land, landOwners){
		const {getters} = this.context;
		var stats = [0,0];
		if(landOwners.length){

			const lId = landOwners[0]

			const o = this.tc.scenario.landowners.find((ow)=>{return ow.id == lId});

			if(o && o.properties){
				const prop = o.properties.find((p)=>{return p.id == land.properties.vindrid});
				if(prop && prop.area && prop.totalArea)
					stats = [prop.totalArea, prop.area];
			}
			else {
				stats = [0,0];
			}
		}
		
		return (
			<>
				{!!land.properties.vindrid &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<i className="ri-circle-fill mr-2" style={{color:land.properties.color}}></i>

						<button className="btn btn-text p-0">
							<b>ID: </b>
							{land.properties.vindrid }
						</button>
					</Col>
				</Row>
				}


				{landOwners.length>1 &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Info className="text-warning mr-2" size={16} />
						This property has multiple owners
					</Col>
				</Row>
				}

				{!!land.properties.name && 
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Building size={16} />
						<b>Name: </b>
						{land.properties.name}
					</Col>
				</Row>
				}
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Pentagon size={16} />
						<b>Total property size: </b>
						{formatArea(stats[0], getters.user)}
					</Col>
				</Row>
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Polygon size={16} />
						<b>{this.areaLabel()}: </b>
						{formatArea(stats[1], getters.user)}
					</Col>
				</Row>
				
			</>
		);
	}
	
	areaLabel(){
		return 'Property within boundary';
	}
}

export default WorkmodeProject;